import type { CustomContext } from "@rebuild/shared";

interface ConfirmDeleteModalProps {
  entry: CustomContext;
  onClose: () => void;
  onConfirm: () => void;
}

function ConfirmDeleteModal({ entry, onClose, onConfirm }: ConfirmDeleteModalProps) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg w-96 relative">
        <div className="p-6">
          <h2 className="text-xl font-bold text-gray-800 mb-4">Delete Custom Context</h2>
          <p className="text-gray-600 mb-6">Delete the custom context "{entry.title}"? This action cannot be undone.</p>
          <div className="flex gap-3">
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 font-medium"
            >
              Cancel
            </button>
            <button onClick={onConfirm} className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 font-medium">
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDeleteModal;
